import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	useBlogPostsQueryQuery,
	type useBlogPostsQueryQuery$data,
	type useBlogPostsQueryQuery$variables,
} from '@confluence/blog-posts-macro/entry-points/useBlogPostsQueryQuery.ts';
import { buildQueryVariables } from '@confluence/blog-posts-macro/entry-points/dataUtils.ts';
import type { BlogPostsMacroParams } from '@confluence/blog-posts-macro/entry-points/blogPostMacroTypes.ts';

import type {
	MacroContentNode,
	MacroPreloadHandler,
	MacroPreloadContext,
} from '../preloadMacroData.ts';

/**
 * Preload handler for the blog posts macro.
 *
 * For a blog-posts extension node found in the ADF content, this handler
 * builds query variables from the macro parameters and fires the
 * useBlogPostsQueryQuery GraphQL query to populate the Relay store.
 */
export const blogPostsPreloadHandler: MacroPreloadHandler = {
	extensionKey: 'blog-posts',

	routes: ['view', 'space-overview', 'edit', 'live'],

	preload: async (node: MacroContentNode, context: MacroPreloadContext): Promise<void> => {
		const macroParams = (node.attrs?.parameters?.macroParams ?? {}) as BlogPostsMacroParams;
		const variables = buildQueryVariables(macroParams, context.spaceKey);
		await query<useBlogPostsQueryQuery$data, useBlogPostsQueryQuery$variables>({
			query: useBlogPostsQueryQuery,
			variables,
			context: { single: true },
		});
	},
};
